@if (navMode === hiddenMode) {
} @else if (navMode === bottomBarMode) {
  <shared-bottom-nav-bar
    [slots]="quickAccessSlots"
    [suppressNavigation]="suppressNavigation"
    [showHint]="showCustomizerHint"
    (longPress)="onQuickAccessLongPress()"
    (actionClick)="onActionSlotClick($event)"
    (dismissHint)="dismissCustomizerHint()">
  </shared-bottom-nav-bar>
} @else {
  <shared-floating-quick-access
    [slots]="quickAccessSlots"
    [showHint]="showCustomizerHint"
    [initialPositionY]="floatingPositionY"
    [initialSide]="floatingSide"
    [suppressNavigation]="suppressNavigation"
    (customize)="onQuickAccessLongPress()"
    (dismissHint)="dismissCustomizerHint()"
    (positionChanged)="onFloatingPositionChanged($event)"
    (sideChanged)="onFloatingSideChanged($event)"
    (actionClick)="onActionSlotClick($event)">
  </shared-floating-quick-access>
}
